import styled from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";
import PropTypes from 'prop-types';

const sectionThemes = {
    light: '#F7FAF2',
    dark: '#1F1F1F'
};

const Section = styled.div`
    min-height: 450px;
    border-top: 2px solid ${MAIN_COLOR};
    background-color: ${({theme}) => sectionThemes[theme]};
    display: flex;
    position: relative;
    flex-wrap: wrap;
    overflow: hidden;
    align-items: ${({alignItems}) => alignItems ?? 'center'};
    justify-content: ${({justifyContent}) => justifyContent ?? 'center'};
    width: 100%;
`;

Section.propTypes = {
    theme: PropTypes.oneOf(['dark', 'light']),
    alignItems: PropTypes.oneOf(['stretch', 'center', 'start', 'end']),
    justifyContent: PropTypes.oneOf(['center', 'start', 'space-between', 'space-around', 'space-evenly'])
};

Section.defaultProps = {
    theme: 'light'
};

export default Section;
